import React, { useEffect, useState, useRef } from "react";

const slides = [
  { label: "wesele", image: "/assets/otwarte/otwarte8.webp" },
  { label: "event", image: "/assets/zamkniete/zamkniete18.webp" },
  { label: "studniówkę", image: "/assets/zamkniete/zamkniete16.webp" },
  { label: "urodziny", image: "/assets/zamkniete/zamkniete17.webp" },
];

export default function HeroSection() {
  const [index, setIndex] = useState(0);
  const [anim, setAnim] = useState(true);
  const timeoutRef = useRef();
  const touchStartX = useRef(null);
  const mouseStartX = useRef(null);

  // Auto slide
  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setAnim(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % slides.length);
        setAnim(true);
      }, 200);
    }, 4000);
    return () => clearTimeout(timeoutRef.current);
  }, [index]);

  // Manual navigation
  const goTo = (i) => {
    setAnim(false);
    setTimeout(() => {
      setIndex(i);
      setAnim(true);
    }, 200);
  };

  // Swipe/drag handlers
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(delta) > 50) {
      if (delta < 0) goTo((index + 1) % slides.length);
      else goTo((index - 1 + slides.length) % slides.length);
    }
    touchStartX.current = null;
  };
  const handleMouseDown = (e) => {
    mouseStartX.current = e.clientX;
  };
  const handleMouseUp = (e) => {
    if (mouseStartX.current === null) return;
    const delta = e.clientX - mouseStartX.current;
    if (Math.abs(delta) > 50) {
      if (delta < 0) goTo((index + 1) % slides.length);
      else goTo((index - 1 + slides.length) % slides.length);
    }
    mouseStartX.current = null;
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-end px-4 sm:px-6 pb-16 sm:pb-20 md:pb-24 overflow-hidden select-none"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      {/* Obrazy w tle z efektem zoom i płynnym przejściem */}
      {slides.map((slide, i) => (
        <img
          key={i}
          src={slide.image}
          alt={`DJ na ${slide.label}`}
          loading={i === 0 ? "eager" : "lazy"}
          width={1920}
          height={1080}
          className={`absolute inset-0 w-full h-full object-cover object-center transition-all duration-1000 ease-in-out ${
            i === index && anim ? "opacity-100 scale-105" : "opacity-0 scale-100"
          }`}
          style={{ zIndex: 0 }}
          fetchpriority={i === 0 ? "high" : "auto"}
        />
      ))}

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70 z-0" />

      {/* Treść */}
      <div className="relative z-10 w-full text-white text-left transition-opacity duration-700 ease-in-out">
        <p className="text-xs sm:text-sm tracking-widest uppercase text-gray-300 mb-4">
          DJ na {" "}
          <span
            className={`${anim ? "opacity-100" : "opacity-0"} transition-opacity duration-500`}
          >
            {slides[index].label.charAt(0).toUpperCase() + slides[index].label.slice(1)} z klasą
          </span>
        </p>
        <h1 className="text-3xl xs:text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight mb-4">
          <span
            className={`${anim ? "opacity-100" : "opacity-0"} transition-opacity duration-500`}
          >
            {slides[index].label.charAt(0).toUpperCase() + slides[index].label.slice(1)} z klasą
          </span>
        </h1>
        <p className="text-xs sm:text-sm text-gray-300 mb-8 tracking-wide uppercase">
          Stwórzmy razem niezapomniane wydarzenie. Zróbmy to profesjonalnie.
        </p>
        <button
          onClick={() => {
            const el = document.getElementById("o-mnie");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}
          className="inline-block border-2 border-white px-8 py-3 text-base sm:text-lg font-semibold text-white tracking-wide rounded-lg hover:bg-white hover:text-black transition focus:outline-none focus:ring-4 focus:ring-orange-300"
        >
          POZNAJ MNIE!
        </button>
        {/* Wskaźniki i strzałki */}
        <div className="flex items-center gap-3 mt-8 flex-wrap">
          {slides.map((s, i) => (
            <button
              key={i}
              aria-label={`Pokaż: ${s.label}`}
              className={`w-3 h-3 rounded-full border-2 border-white transition-all duration-300 ${i === index ? "bg-white" : "bg-transparent"}`}
              onClick={() => goTo(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
